import { EquipmentRental } from './equipment-rental';

export interface IRentalOrder {
  id?: number;
  consecutive: number;
  providerId: number;
  userDeliveryId: number;
  userReceivesId: number;
  stateId: number;
  comment: string;
  startDate: string;
  startTime: string;
  endTime: string;
  providerName: string;
  providerAddress: string;
  userDeliveryName: string;
  userReceivesName: string;
  stateName: string;
  endDate: string;
  equipments: Array<EquipmentRental>;
  userIncomeName: string;
  incomeDate: string;
  incomeComment: string;
  userDispatchName: string;
  dispatchDate: string;
  dispatchComment: string;
  userState2Name: string;
  state2Date: string;
  state2Comment: string;
  userState3Name: string;
  state3Date: string;
  state3Comment: string;
  created?: string;
  createdBy?: number;
  updated?: string;
  updatedBy?: number;
  updateResources?: boolean;
}

export class RentalOrder implements IRentalOrder {
    id?: number;
    consecutive: number;
    providerId: number;
    userDeliveryId: number;
    userReceivesId: number;
    stateId: number;
    comment: string;
    startDate: string;
    startTime: string;
    endTime: string;
    providerName: string;
    providerAddress: string;
    userDeliveryName: string;
    userReceivesName: string;
    stateName: string;
    endDate: string;
    equipments: Array<EquipmentRental>;
    userIncomeName: string;
    incomeDate: string;
    incomeComment: string;
    userDispatchName: string;
    dispatchDate: string;
    dispatchComment: string;
    userState2Name: string;
    state2Date: string;
    state2Comment: string;
    userState3Name: string;
    state3Date: string;
    state3Comment: string;
    created?: string;
    createdBy?: number;
    updated?: string;
    updatedBy?: number;
    updateResources?: boolean;
}
